import React, { Component } from 'react';

import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap";

// Redux
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

// availity-reactstrap-validation
import { AvForm, AvField } from 'availity-reactstrap-validation';

// actions
import { loginUser, apiError } from '../../store/actions';
import "../Marketing/marketing.css";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/tracklastmile-logo.svg";

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {}

        // handleValidSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
    }

    // handleValidSubmit
    handleValidSubmit(event, values) {
        this.props.loginUser(values, this.props.history);
    }

    componentDidMount() {
        this.props.apiError("");
    }

    render() {
        console.log('apiError' + this.props.error);
        return (
            <div className="tlm-home tlm-dark tlm-login-page min-vh-100">
                <div className="home-btn d-none d-sm-block">
                    <Link to="/" className="text-dark"><i className="bx bx-home h2"></i></Link>
                </div>
                <div className="d-flex justify-content-center pt-4 pb-2">
                    <Link to="/">
                        <img src={logo} alt="TrackLastMile" className="img-fluid d-block tlm-home-logo" />
                    </Link>
                </div>
                <div className="account-pages my-5 pt-sm-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="overflow-hidden tlm-card tlm-login-card border-0">
                                    <div className="tlm-soft-primary-dark">
                                        <Row>
                                            <Col className="col-7">
                                                <div className="text-dark p-4">
                                                    <h5 className="text-dark">The All-in-One Delivery Platform</h5>
                                                    <p className="mb-0 tlm-login-lead">Sign in to continue to <br /> TrackLastMile - your branded delivery business</p>
                                                </div>
                                            </Col>
                                            <Col className="col-5 align-self-end">
                                                <img src={profile} alt="" className="img-fluid" />
                                            </Col>
                                        </Row>
                                    </div>
                                    <CardBody className="pt-0 p-4">
                                        <div className="p-1">

                                            <AvForm className="form-horizontal" onValidSubmit={this.handleValidSubmit}>

                                                {this.props.error && this.props.error.response && this.props.error.response.data ? <Alert color="danger">{this.props.error.response.data.message}</Alert> : null}
                                                <div className="form-group">
                                                    <AvField name="email" label="Mobile number" value="5194762069" className="form-control" placeholder="Enter 10 digit mobile number" type="phoneNumber" required />
                                                </div>

                                                <div className="form-group">
                                                    <AvField name="password" label="Password" value="Admin789" type="password" required placeholder="Enter Password" />
                                                </div>

                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id="customControlInline" />
                                                    <label className="custom-control-label" htmlFor="customControlInline">Remember me</label>
                                                </div>

                                                <div className="mt-3">
                                                    <button className="btn btn-primary btn-block waves-effect waves-light" type="submit">Log In</button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <Link to="/forgot-password" className="tlm-text-muted"><i className="mdi mdi-lock mr-1"></i> Forgot your password?</Link>
                                                </div>
                                            </AvForm>
                                        </div>
                                    </CardBody>
                                </Card>
                                <div className="mt-5 text-center">
                                    <p>Launch your own branded food delivery service, <br />Register with us. <Link to="trial-register" className="font-weight-medium text-primary"> Signup now </Link> </p>
                                    <p>© {new Date().getFullYear()} TrackLastMile. Crafted with {" "} <i className="mdi mdi-heart text-danger"></i> TurboDevelop</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const mapStatetoProps = state => {
    const { error } = state.Login;
    return { error };
}

export default withRouter(connect(mapStatetoProps, { loginUser, apiError })(Login));

